








































import { Component, Prop, Vue } from 'vue-property-decorator';
import Modal from '@/main-components/common/modal/Modal.vue';
import Form, {
  InputData,
  OnSubmitReturn,
} from '@/main-components/common/Form.vue';
import UserStore, { UserStoreInterface } from '@/resource/user/user.store';
import {
  checkCoupon,
  SubscriptionType,
} from '@/utils/subscription/subscription.util';

@Component({
  components: {
    Modal,
    Form,
  },
})
export default class ModalSignInUp extends Vue {
  @Prop({ default: null })
  nextActon: () => Promise<void> | null;

  @Prop({ default: null })
  subscriptionType!: SubscriptionType;

  @Prop({ default: false })
  isHideCoupon!: false;

  @Prop({ default: null })
  description: string | null;

  openModal: any = null;
  closeModal: any = null;
  userStore: UserStoreInterface = UserStore;
  isForgotPassword = false;

  inputs: InputData[] = [
    {
      name: 'email',
      value: '',
      placeholder: 'Emel anda',
      type: 'text',
      isRequired: true,
      isEmail: true,
    },
    {
      name: 'phoneNumber',
      value: '',
      placeholder: 'Nombor telefon e.g. 0123754239',
      type: 'text',
      isRequired: true,
    },
    {
      name: 'role',
      value: '',
      placeholder: 'Pilih kategori anda ',
      type: 'dropdown',
      isRequired: true,
      dropdownOptions: [
        {
          value: 'teacher',
          text: 'Guru',
          isSelected: false,
        },
        {
          value: 'student',
          text: 'Murid',
          isSelected: false,
        },
        {
          value: 'parent',
          text: 'Ibu Bapa',
          isSelected: false,
        },
      ],
    },
    {
      name: 'password',
      value: '',
      placeholder: 'Kata laluan',
      type: 'password',
      isRequired: true,
      hasMinimum: 6,
    },
  ];

  get coupon() {
    return (
      this.$route.query &&
      this.$route.query['coupon'] &&
      (this.$route.query['coupon'] as string)
    );
  }

  created() {
    if (!this.coupon && !this.isHideCoupon) {
      this.inputs.push({
        name: 'coupon',
        value: this.coupon ? this.coupon : '',
        placeholder: 'Kod Promo (tidak wajib)',
        type: 'text',
        isRequired: false,
        apiValidate: async (input: string) => {
          const isValidCoupon = await checkCoupon({
            coupon: input,
            subscriptionType: this.subscriptionType,
          });

          return isValidCoupon ? false : true;
        },
      });
    }
  }

  mounted() {
    this.$emit('ModalSignInUpAdd', this.openModal);
  }

  openModalAdd(openModal: any) {
    this.openModal = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModal = closeModal;
  }

  async onRegisterSubmit(bodyRequest: any): Promise<OnSubmitReturn | null> {
    await this.userStore.signin(bodyRequest);

    if (this.userStore.error) {
      const firstName = bodyRequest.email.split('@')[0];
      await this.userStore.signup({
        firstName,
        lastName: '',
        ...bodyRequest,
      });

      if (
        this.userStore.error &&
        this.userStore.error.code === 'email_already_in_used'
      ) {
        this.userStore.error.message = 'Email and password not match';
        this.isForgotPassword = true;

        this.$sendMpEvent({
          event: this.$mp_value.ErrorSignup,
          properties: {
            error: this.userStore.error.message,
            email: bodyRequest ? bodyRequest.email : '',
          },
        });

        return { error: this.userStore.error };
      } else if (
        this.userStore.error &&
        this.userStore.error.code === 'phone_number_already_in_used'
      ) {
        this.userStore.error.message = 'Nombor telefon sudah digunakan';

        this.$sendMpEvent({
          event: this.$mp_value.ErrorSignup,
          properties: {
            error: this.userStore.error.message,
            phone: bodyRequest ? bodyRequest.phoneNumber : '',
          },
        });

        return { error: this.userStore.error };
      } else {
        this.$sendMpEvent({
          event: this.$mp_value.Signup,
          properties: {
            email: bodyRequest.email,
            phoneNumber: bodyRequest.phoneNumber,
          },
        });
        await this.userStore.signin(bodyRequest);
      }
    } else {
      this.$sendMpEvent({ event: this.$mp_value.SignIn });
    }

    if (!this.userStore.error && this.nextActon) {
      await this.nextActon();
      this.closeModal && this.closeModal();
    }

    this.isForgotPassword = false;
    return null;
  }
}
